import { PropsWithChildren, Suspense } from 'react'

import { LoadingPage } from 'layout/loadingPage/LoadingPage'

type Props = PropsWithChildren<{}>

export const SuspenseLoader = ({ children }: Props) => <Suspense fallback={<LoadingPage />}>{children}</Suspense>
